import { StepConnector, Stepper, styled } from "@mui/material";

export const StepperStyle = styled(Stepper)(
  ({
    theme,
    margin,
    background,
    borderColor,
    borderRadius,
    padding,
    gap,
    marginTop,
  }) => ({
    margin: margin || "1rem 0rem 4rem",
    background: background,
    borderRadius: borderRadius,
    padding: padding,

    "& .MuiStepLabel-root": {
      padding: "0px",
      flexDirection: "column",
      gap: gap || "1rem",
    },
    "& .MuiStepConnector-root": {
      marginLeft: "0px !important",
    },
    "& .MuiStepConnector-line": {
      marginTop: marginTop || "1.5rem",
      borderColor: borderColor || "#EBF1F4",
      borderTopWidth: "4px",
    },
    "& .Mui-active": {
      color: "#17B26A",
    },
    "& .Mui-active .MuiStepConnector-line": {
      borderColor: "#17B26A",
    },
    "& .Mui-completed .MuiStepConnector-line": {
      borderColor: "#17B26A",
    },

    [theme.breakpoints.down("md")]: {
      width: "100% !important",
    },
  })
);

export const CustomStepConnector = styled(StepConnector)(
  ({ completedSteps }) => ({
    "& .MuiStepConnector-line": {
      borderTopWidth: "4px",
      flex: 1,
      borderColor: completedSteps ? "#17B26A" : "#EBF1F4",
    },
  })
);
